module.exports = __webpack_public_path__ + "static/media/loginScreen.099f1f9b.png";